import { api } from '@/lib/axios'

export async function TimeFn() {
  const response = await api.get('time')

  return response.data
}
